import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CreateMessageService } from '../create-message.service';
import { LayoutService } from '../../../common/layout/layout.service';
import { MobileDetectorService } from '../../../common/shared/mobile-detector.service';
import { HeadlessView } from '../../../common/shared/components/headless-view';

@Component({
    selector: 'app-makes-list',
    templateUrl: './makes-list.component.html',
    styleUrls: ['./makes-list.component.scss']
})
export class MakesListComponent extends HeadlessView implements OnInit {

    public makes;
    public model = {};

    constructor(
        protected layoutService: LayoutService,
        protected mobileDetectorService: MobileDetectorService,
        private activatedRoute: ActivatedRoute,
        private createMessageService: CreateMessageService,
        private router: Router,
    ) {
        super(layoutService, mobileDetectorService);
        this.makes = activatedRoute.snapshot.data['makes'];

        this.createMessageService.clearSelection();

        this.layoutService.disableFooter();
    }

    ngOnInit(): void {
    }

    public onGoBack() {
        this.router.navigate(['dashboard']);
    }
    public onNext() {
        this.createMessageService.saveMakesSelection(this.model);
        this.router.navigate(['..', 'wybierz-dokumenty'], { relativeTo: this.activatedRoute });
    }

    public onItemClick(id, event) {
        if (event.target.nodeName !== 'INPUT') {
            this.model[id] = !this.model[id];
        }
    }

    public hasSelection() {
        for (let modelKey in this.model) {
            if (this.model.hasOwnProperty(modelKey)) {
                if (this.model[modelKey]) {
                    return true;
                }
            }
        }

        return false;
    }
}
